const permissions = {
  STORE_SHOPIFY_INTEGRATION: 'store-shopify-integration',
  STORE_API_ACCESS: 'store-api-access'
}

export default {
  permissions
}
